var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconApprovalsModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_5_4",
    "data-name": "Componente 5 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Componente_6_1",
    "data-name": "Componente 6 \\u2013 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2011",
    "data-name": "Grupo 2011",
    transform: "translate(-146 -687)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_40",
    "data-name": "Elipse 40",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(146 687)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2012",
    "data-name": "Grupo 2012",
    transform: "translate(-184.421 -618.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1186",
    "data-name": "Caminho 1186",
    d: "M105.765,80.027v1.389H90.713a1.8,1.8,0,0,0-1.092.364l-3.54,2.746v-21.4h19.684v6.319l2.084-2.349V62.825a1.8,1.8,0,0,0-1.786-1.786H85.783A1.779,1.779,0,0,0,84,62.825V85.089a1.8,1.8,0,0,0,.993,1.621,1.763,1.763,0,0,0,.794.2,1.959,1.959,0,0,0,1.092-.364L90.713,83.5h15.35a1.8,1.8,0,0,0,1.786-1.786V78.042l-1.323,1.489a2.028,2.028,0,0,1-.761.5Z",
    transform: "translate(115.034 571.962)",
    fill: "#010066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1187",
    "data-name": "Caminho 1187",
    d: "M170.177,147.714h11.645a1.045,1.045,0,0,0,1.059-1.059,1.066,1.066,0,0,0-1.059-1.059H170.177a1.066,1.066,0,0,0-1.059,1.059,1.088,1.088,0,0,0,1.059,1.059Z",
    transform: "translate(34.942 492.399)",
    fill: "#010066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1188",
    "data-name": "Caminho 1188",
    d: "M182.878,231.777a1.066,1.066,0,0,0-1.059-1.059H170.175a1.066,1.066,0,0,0-1.059,1.059,1.045,1.045,0,0,0,1.059,1.059H181.82a1.045,1.045,0,0,0,1.059-1.059Z",
    transform: "translate(34.944 412.306)",
    fill: "#010066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1189",
    "data-name": "Caminho 1189",
    d: "M169.68,317.423a1.045,1.045,0,0,0,1.059,1.059H180.8l.364-2.084H170.706a1.031,1.031,0,0,0-1.025,1.026Z",
    transform: "translate(34.413 331.688)",
    fill: "#010066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1190",
    "data-name": "Caminho 1190",
    d: "M422.12,168.863l6.2-6.923,2.956,2.649-6.2,6.923Z",
    transform: "translate(-203.114 477.021)",
    fill: "#010066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1191",
    "data-name": "Caminho 1191",
    d: "M547.3,120.3l-2.051-1.853a.579.579,0,0,0-.827.033l-1.224,1.389,2.944,2.647,1.224-1.389a.613.613,0,0,0-.066-.827Z",
    transform: "translate(-317.043 518.096)",
    fill: "#010066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1192",
    "data-name": "Caminho 1192",
    d: "M385.333,301.131l2.514-.728a.719.719,0,0,0,.265-.165l.728-.794-2.944-2.647-.728.794a.593.593,0,0,0-.132.3l-.43,2.58A.591.591,0,0,0,385.333,301.131Z",
    transform: "translate(-167.808 350.13)",
    fill: "#010066"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApprovalsModal);
export default __webpack_public_path__ + "static/media/icon_approvalsModal.46ab22c5de3091db4014e0a0db690207.svg";
export { ForwardRef as ReactComponent };